import React, { useState } from 'react';
import TopNav from '../../../Components/TopNav';
import Navbar from '../../../Components/Navbar';
import DropdownNav from '../../../Components/DropdownNav';
import './about.css'
import Footer from '../../../Components/Footer';
import Example from '../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const CodeofConduct = () => {
  const [toggle, setToggle] = useState(1)

  function updateToogle(id) {
    setToggle(id)
  }
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='init-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      <div className='Measi-details'>
        <div className='measi-header'>
          <h2>Infrastructure → Code of Conduct</h2>
          <p>The New College infrastructure is one of the biggest & best in Tamil Nadu.</p>
        </div>

        <div className='tab-main'>
          <ul className='tab-details'>
            <li className={toggle === 1 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(1)}>Code of Conduct</li>
          </ul>


          {/* Tab One Details */}

          <div className={toggle === 1 ? "show-tab-content" : 'tab-content'}>
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}

              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/code_of_conduct.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Code of Conduct Report</h3>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );

}

export default CodeofConduct;
